import queryString from 'query-string';

export const MEDIA_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

export const MEDIA_SOURCES = {
  VIMEO: 'vimeo',
};

export const getMedia = media => {
  if (!media || typeof media !== 'object' || Array.isArray(media)) {
    return null;
  }
  const { type, source } = media;
  if (MEDIA_TYPES.IMAGE === type) {
    return source;
  }
  if (MEDIA_TYPES.VIDEO === type) {
    if (MEDIA_SOURCES.VIMEO === source) {
      return `https://player.vimeo.com/video/${media.id}?title=0&byline=0`;
    }
  }
  return null;
};

const isTrueObject = value =>
  typeof value === 'object' && !Array.isArray(value);

export const encodeUrlParams = params => {
  if (typeof params !== 'object') {
    return '';
  }

  const sanitizedParams = Object.keys(params).reduce((acc, curr) => {
    let value = params[curr];
    if (Array.isArray(value)) {
      value = value.map(v => (isTrueObject(v) ? JSON.stringify(v) : v));
    }
    if (isTrueObject(value)) {
      value = JSON.stringify(value);
    }
    return {
      ...acc,
      [curr]: value,
    };
  }, {});
  return queryString.stringify(sanitizedParams, {
    arrayFormat: 'index',
    encode: true,
  });
};

export const defaultActionUrlCreator = ({ id, promoCode, urlParams }) => {
  const params = {
    ...urlParams,
    pageid: id,
    promo: promoCode,
  };
  return `/redirect/join?${encodeUrlParams(params)}`;
};



// WEBPACK FOOTER //
// ./src/App/join/Templates/utilities.js